import { isLocalhost } from "./isLocalhost";
export const isInDevelopmentMode = isLocalhost;
